import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import NewBrandLogo from '../../assets/images/FreightSmith_LOGO_Final.png'
import { showAlert } from "../../Utils/Utility";
import { resetPasswordAction } from '@mobile-dev/platform/common/redux/actions/CarrierLogin';
import { clearError } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import ErrornDialog from "../Common/ErrorDialog/ErrorDialog";
import LoaderButton from "../Common/LoaderButton";

function ResetPassword() {
    const location = useLocation();
    const userName = location.state.username;
    const [password, setPassword] = useState({ pwd1: '', pwd2: '' });
    const [code, setCode] = useState('');
    const dispatch = useDispatch();
    const history = useHistory();
    const resetPassword = useSelector(state => state.carrierLogin.resetPassword);
    const error = useSelector(state => state.carrierLogin.error);
    const loading = useSelector(state => state.carrierLogin.loading);

    useEffect(() => {
        if(resetPassword==='SUCCESS'){
            history.push('/carrierLogin');
            showAlert(toast.TYPE.SUCCESS,"Password has been updated succesfully.");
            return null;
        }
    }, [resetPassword]);

    useEffect(() => {
        dispatch(clearError());
    }, []);

    const handleChange = (e) => {
        setPassword({
            ...password,
            [e.target.name]: e.target.value
        });

    }

    const handleCode = (e) => {
        setCode(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password.pwd1 === password.pwd2) {
            if (code) {
                dispatch(resetPasswordAction(userName.trim(), code.trim(), password.pwd1.trim(),showAlert));
            }
            else{
                showAlert(toast.TYPE.WARNING,"Please enter the Verification Code received via email.")
            }
        }
        else {
            showAlert(toast.TYPE.WARNING, "Password doesn't match,Please enter the same password")
        }
    }

    return (
        <form className="form-signin">
            <div className="card">

                <div className="card-header uc-blue"></div>

                <div className="card-header text-center bg-header">
                    <span className="text-dark-50 fa-lg">
                        <img className="img-fluid smith_logo" src={NewBrandLogo} alt="FreightSmith logo" />
                    </span>
                </div>
                <div className="card-body p-4">
                    <div className="mb-3">
                        <label htmlFor="code" className="required"> Enter the verification code</label>
                        <input className="form-control" type="tel" id="code" name="code" placeholder="Verification Code" onChange={handleCode} required autoFocus />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="required"> Enter the New Password</label>
                        <input className="form-control" type="password" name="pwd1" placeholder="New Password" onChange={handleChange} required autoFocus />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="RePassword" className="required">Re-Enter the Password</label>
                        <input className="form-control" type="password" name="pwd2" placeholder="Re-enter Password" onChange={handleChange} required autoFocus />
                    </div>
                    <LoaderButton
                        loading={loading}
                        onButtonClick={handleSubmit}
                        name='Submit'
                        className="btn btn-chartreuse btn-height btn-block"
                    />
                </div>
            </div>
            {error && <ErrornDialog
                error={error?.message}
                open
            />}
        </form>
    )
}

export default ResetPassword;